import { useEffect, useState } from "react";
import { L10nId } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { logger } from "@fidget/common/utils";
import { useStore } from "../../../../models";
import { config } from "@fidget/common/config/config";

interface Props {
  onDelete?: () => Promise<void>;
  removeFromUi?: () => void;
  deleteToastId?: L10nId;
}
interface State {
  wasDeleteClicked: boolean;
  setWasDeleteClicked: (value: boolean) => void;
  onRemove: () => Promise<void>;
  removeFromUiTimer?: number;
}

export const deletingFormState = ({ onDelete, removeFromUi, deleteToastId }: Props): State => {
  const { uiStore } = useStore();
  const [wasDeleteClicked, setWasDeleteClicked] = useState<boolean>(false);
  const [removeFromUiTimer, setRemoveFromUiTimer] = useState<number>();

  useEffect(
    () => () => {
      if (removeFromUiTimer) {
        clearTimeout(removeFromUiTimer);
      }
    },
    []
  );

  const onRemove = async () => {
    if (onDelete && removeFromUi) {
      try {
        await onDelete();
        const timer: number = window.setTimeout(
          removeFromUi,
          config.services.times.timeoutSettingsDeleteConfirmationMs
        );
        setRemoveFromUiTimer(timer);
      } catch (e) {
        logger.error({ message: "Couldn't delete entry", error: e });
        if (deleteToastId) {
          uiStore.addErrorToast(intl.formatMessage(deleteToastId));
        } else {
          uiStore.addGenericErrorToast();
        }
      }
    }
  };

  return {
    onRemove,
    wasDeleteClicked,
    setWasDeleteClicked,
    removeFromUiTimer
  };
};
